import { SellingPlan } from '../../models/selling-plan'
import { getSellingPlanAllocationForVariant } from '../../models/selling-plan-allocation'

export const sortingByPrice = (groupId: string) => (plan1: SellingPlan, plan2: SellingPlan) => {
  const pricePlan1 = getSellingPlanAllocationForVariant(groupId, plan1.id)
  const pricePlan2 = getSellingPlanAllocationForVariant(groupId, plan2.id)
  return pricePlan1 - pricePlan2
}
